import { Link, NavLink, Outlet, useNavigate } from 'react-router-dom';
import { useAuth } from '../auth/AuthProvider';

export function Layout() {
  const { user, profile, signOut } = useAuth();
  const navigate = useNavigate();

  async function handleSignOut() {
    await signOut();
    navigate('/login', { replace: true });
  }

  return (
    <div className="app-shell">
      <header className="app-header">
        <Link to="/difot" className="brand">
          Bing Lee · DIFOT
        </Link>
        <nav className="primary-nav">
          <NavLink to="/difot">DIFOT Report</NavLink>
          <NavLink to="/tv">TV Mode</NavLink>
          <NavLink to="/feedback">Customer Feedback</NavLink>
          {profile?.role === 'admin' && <NavLink to="/admin/users">Users</NavLink>}
        </nav>
        <div className="user-menu">
          <span className="user-email">{user?.email}</span>
          <button type="button" onClick={handleSignOut}>
            Sign out
          </button>
        </div>
      </header>
      <main className="app-main">
        <Outlet />
      </main>
    </div>
  );
}
